import { registerCustomElement } from './utils.mjs';
import './alerts.scss';

export class Alerts extends HTMLElement {
	addAlert(msg: string, detail?: string) {
		const alert = createAlert(msg, detail);
		this.appendChild(alert);

		return alert;
	}
}

registerCustomElement('imt-alerts', Alerts);

export function createAlert(msg: string, detail?: string) {
	const template = document.createElement('template');
	const templateBody = `
	<div class="alert-message dmo-bg-bastda-secondary dmo-flex dmo-flex-row dmo-gap-10 dmo-p-16 dmo-paragraph-md dmo-pl-14 dmo-rounded-md dmo-text-testde-primary" aria-label="danger">
		<div class="dmo-flex dmo-items-center">
			<i data-testid="static-message-icon" class="dmo-icon-lg dmo-mr-2 dmo-text-icstda-primary domino-icon-error-circle-solid"></i>
		</div>
		<div data-testid="static-message-content" class="dmo-w-full dmo-min-w-0">
			<header data-testid="static-message-title" class="dmo-font-semibold dmo-break-words">${msg}</header>
			${detail ?? ''}
		</div>
		<div class="dmo-pl-2 dmo-leading-none dmo-text-icwa-secondary dmo-flex dmo-items-center">
			<button data-testid="static-message-close-btn">
				<i class="dmo-far before:dmo-fa-xmark dmo-text-base icon"></i>
			</button>
		</div>
	</div>`;
	template.insertAdjacentHTML('beforeend', templateBody);

	const alert = template.children[0];
	alert?.querySelector('button')?.addEventListener('click', () => {
		alert.remove();
	});

	return alert;
}
